import { Injectable } from '@angular/core';
import { MockStudent } from '../data/mock-students';
import { MiniGameStudent, StudentTeam } from '../interfaces/mini-game.interface';

const AVATAR_COLORS = [
  '#E57373', '#F06292', '#BA68C8', '#9575CD', '#7986CB',
  '#64B5F6', '#4FC3F7', '#4DD0E1', '#4DB6AC', '#81C784',
  '#AED581', '#FFD54F', '#FFB74D', '#FF8A65', '#A1887F',
  '#90A4AE', '#7E57C2', '#5C6BC0', '#26A69A', '#66BB6A'
];

@Injectable({ providedIn: 'root' })
export class ClassStudentsService {

  private confirmedStudents: MockStudent[] = [];

  setRealStudents(students: MockStudent[]): void {
    this.confirmedStudents = students;
  }

  getStudentsByClass(classId: number): MiniGameStudent[] {
    return this.confirmedStudents
      .filter(s => s.class_id === classId)
      .map(s => this.enrichStudent(s));
  }

  getAllStudents(): MiniGameStudent[] {
    return this.confirmedStudents.map(s => this.enrichStudent(s));
  }

  generateTeams(students: MiniGameStudent[]): { teamA: StudentTeam; teamB: StudentTeam } {
    const shuffled = [...students].sort(() => Math.random() - 0.5);
    const mid = Math.ceil(shuffled.length / 2);

    const teamAStudents = shuffled.slice(0, mid).map(s => ({ ...s, teamId: 'A' as const }));
    const teamBStudents = shuffled.slice(mid).map(s => ({ ...s, teamId: 'B' as const }));

    return {
      teamA: {
        id: 'A',
        name: { en: 'Blue Team', ar: 'الفريق الأزرق' },
        color: '#2196F3',
        students: teamAStudents,
        score: 0
      },
      teamB: {
        id: 'B',
        name: { en: 'Red Team', ar: 'الفريق الأحمر' },
        color: '#F44336',
        students: teamBStudents,
        score: 0
      }
    };
  }

  getRandomStudent(students: MiniGameStudent[]): MiniGameStudent {
    return students[Math.floor(Math.random() * students.length)];
  }

  private enrichStudent(student: MockStudent): MiniGameStudent {
    return {
      ...student,
      avatarColor: this.getAvatarColor(student.id),
      initials: this.getInitials(student.name)
    };
  }

  private getAvatarColor(id: number): string {
    return AVATAR_COLORS[(id - 1) % AVATAR_COLORS.length];
  }

  private getInitials(name: { en: string; ar: string }): string {
    const parts = name.en.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  }
}
